export const REDIRECT_QUERY_KEY = 'redirect';
export const GLOBAL_REDIRECT_URL = 'global-redirect';
